module.exports = __webpack_public_path__ + "fonts/45b04e45ac90348cc0b870ae24028878.txt";